import { useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Box } from "@material-ui/core";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

import { columnTextField } from "utils/tables-utils";

import {
  setSelectedProducts,
  removeProduct,
} from "redux/reducers/criarVitrineReducer";

export default function ProductsTable({
  totalSize,
  currentPage,
  currentSizePerPage,
  setProductsTablePagination,
}) {
  const dispatch = useDispatch();

  const selectedProducts = useSelector(
    (state) => state.criarVitrine.selectedProducts,
  );

  const handleDelete = useCallback(
    (codigo) => {
      dispatch(removeProduct(codigo));
    },
    [dispatch],
  );

  const handleDeleteAll = useCallback(() => {
    dispatch(setSelectedProducts([]));
  }, [dispatch]);

  const columnModel = useMemo(
    () => [
      columnTextField({
        dataField: "Codigo",
        text: "Cód. Produto",
        align: "center",
      }),
      columnTextField({
        dataField: "nome",
        text: "Nome Comercial",
        align: "left",
        formatter: (_, row) => row?.nome ?? row?.Nome ?? "",
      }),
      columnTextField({
        dataField: "LinhaProduto",
        text: "Linha",
        align: "center",
      }),
      columnTextField({
        dataField: "Marca",
        text: "Marca",
        align: "center",
      }),
      columnTextField({
        dataField: "UnidadeMedida",
        text: "Unid. Medida",
        align: "center",
      }),
      columnTextField({
        dataField: "TamanhoMedidas",
        text: "Tamanho",
        align: "center",
      }),
      columnTextField({
        dataField: "QuantidadeDisponivel",
        text: "Estoque",
        align: "center",
      }),
      columnTextField({
        dataField: "FotoPrincipal",
        text: "Imagem",
        align: "center",
        formatter: (_, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ImagePlaceholder
              src={row?.FotoPrincipal ?? row?.foto}
              alt={`Imagem do produto ${row?.Codigo}`}
              width="50px"
              height="50px"
              widthOnError="50px"
              heightOnError="50px"
            />
          </div>
        ),
      }),
      {
        dataField: "actions",
        align: "center",
        headerAlign: "center",
        formatter: (_, row) => (
          <IconButton onClick={() => handleDelete(row.Codigo)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        ),
        headerFormatter: () => (
          <IconButton onClick={handleDeleteAll}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        ),
      },
    ],
    [handleDelete, handleDeleteAll],
  );

  return (
    <Box style={{ minHeight: "450px" }}>
      <ToolkitTable
        keyField="Codigo"
        dataTable={selectedProducts}
        columnModel={columnModel}
        hideEmptyMessages
        pagination={{
          options: [10, 25, 50, 100],
          defaultOption: 10,
          showTotal: true,
          totalSize: totalSize,
          page: currentPage,
          sizePerPage: currentSizePerPage,
        }}
        bootstrapTableProps={{
          onTableChange: (type, { page, sizePerPage }) => {
            if (type === "pagination") {
              setProductsTablePagination({ page, sizePerPage });
            }
          },
        }}
        allowEmpty
      />
    </Box>
  );
}
